<div class="w-12 overflow-hidden bg-col-w pos-relative ratio-5-2">
    <shell></shell>
    <img [fill]="true"
         [ratio]="'ratio-5-2'"
         [dfImage]="content.image">
    <button role="button"
            aria-label="Close"
            (click)="close()"
            class="pos-absolute top-2 right-2 z-2">
        <i class="icon-close col-w"
           aria-hidden="true"></i>
    </button>
</div>

<div class="w-12 p-a-8 p-a-4-s center bg-col-w">
    <h3 class="h1"
        *iCms="'title' of content"></h3>
    <h3 class="p1 m-t-5 m-t-4-s"
        *iCms="'text' of content; skipEmpty: true, content: 'html'"></h3>
    <newsletter-form class="block w-12 m-t-5 m-t-4-s"
                     [source]="'popup'"
                     [successMessage]="'Thank you, you’ll be hearing from us soon.'"
                     (onSubmitSuccess)="closeWithDelay()"></newsletter-form>
    <h3 class="c1 text m-t-5 m-t-4-s"
        *iCms="'bottomCopy' of content; skipEmpty: true, content: 'html'"></h3>
    <button [inlineButton]
            class="m-t-5 m-t-4-s s1"
            (click)="close()">
        <span *iCms="'buttonCopy' of content"></span>
    </button>
</div>
